import axios from 'axios'
import { pythonApiIp, serverIp } from '../../../../config/constants'
import { getShirtTypeDownDownNew,getColorsDropDown, getExpenseAccountsDropDown} from '../LargeProjects/LargeProjectUtils'

export function  getActiveAdminsDropdownList (returnFunction, apiKey){
    console.log("getSales1 ++++++++:getSalesPeople");

    //axios.post(pythonApiIp + 'getSalesPeople', {
    axios.post(serverIp + 'miscEndpoints/getActiveAdminsDropdownList', {
        apiKey: apiKey,
    })
        .then((response) => {
         
           // console.log("getSales12:"+JSON.stringify(response.data,null,3));

            if (response.data.result) {
                console.log("getSales13 true.. adding customer");

                returnFunction(response.data.dropdownItems);
           
            } else {
                console.log("FAILED");
                returnFunction(null);
            }
        })
        .catch((error) => {
            console.log(error);
            returnFunction(null);
        });

}

export function  getExpenseAccounts (returnFunction){
    console.log("expAc1 ++++++++:getExpenseAccounts");

    axios.post(pythonApiIp + 'getExpenseAccounts', {
        apiKey: "ddsdf&343k",
        enteredBy: "ivanmworozi@gmail.com"
    })
        .then((response) => {
         console.log("expAc1:"+JSON.stringify(response.data.expenseAccounts,null,3));

            if (response.data.result) {
               console.log("expAc12 true.. got expenseAccounts");

                returnFunction(getExpenseAccountsDropDown(response.data.expenseAccounts));
           
            } else {
                console.log("FAILED");
                returnFunction(null);
            }
        })
        .catch((error) => {
            console.log(error);
            returnFunction(null);
        });

}


export function  getColors (returnFunction){
    console.log("gcltx1 ++++++++:getColors");

    axios.post(pythonApiIp + 'getColors', {
        apiKey: "ddsdf&343k",
    })
        .then((response) => {
         
          //  console.log("gcltx12:"+JSON.stringify(response.data.shirtColors,null,3));

            if (response.data.result) {
               // console.log("gcltx12 true.. got colors");

                //returnFunction(response.data.shirtTypesToDisplay);
                returnFunction(getColorsDropDown(response.data.shirtColors));
           
            } else {
                console.log("FAILED");
                returnFunction(null);
            }
        })
        .catch((error) => {
            console.log(error);
            returnFunction(null);
        });

}

export function  getShirtTypesToDisplay (returnFunction,shirtTypeDisplay){
    console.log("gshtx1 ++++++++:getShirtTypes");
    console.log("gshtx12 shirtTypeDisplay:"+shirtTypeDisplay);

    axios.post(pythonApiIp + 'getShirtTypeToDisplay', {
        apiKey: "ddsdf&343k",
        shirtTypeDisplay:shirtTypeDisplay
    })
        .then((response) => {
         
            //console.log("gshtx13:"+JSON.stringify(response.data.shirtTypesToDisplay,null,3));

            if (response.data.result) {
                console.log("gsh13 true.. adding items");

                //returnFunction(response.data.shirtTypesToDisplay);
                returnFunction(getShirtTypeDownDownNew(response.data.shirtTypesToDisplay));
           
            } else {
                console.log("FAILED");
                returnFunction(null);
            }
        })
        .catch((error) => {
            console.log(error);
            returnFunction(null);
        });

}

export function  getDeliveryGuys (returnFunction){
    console.log("getDeliveryGuys ++++++++:getDeliveryGuys");

    //axios.post(pythonApiIp + 'getDeliveryGuys', {
    axios.post(serverIp + 'salesApp/getDeliveryGuys', {
        apiKey: "asdf&343sdf",
    })
        .then((response) => {
         
          //  console.log("getDeliveryGuys12:"+JSON.stringify(response.data,null,3));

            if (response.data.result) {
                console.log("getDeliveryGuys true.. ");

                returnFunction(response.data.deliveryGuys);
           
            } else {
                console.log("FAILED");
                returnFunction(null);
            }
        })
        .catch((error) => {
            console.log(error);
            returnFunction(null);
        });

}

export function  getShirtTypes (returnFunction){
    console.log("gsh1 ++++++++:getShirtTypes");

    axios.post(pythonApiIp + 'getShirtTypes', {
        apiKey: "asdf&dfdd",
    })
        .then((response) => {
         
            console.log("gsh12:"+JSON.stringify(response.data,null,3));

            if (response.data.result) {
                console.log("gsh13 true.. adding items");

                returnFunction(response.data.items);
           
            } else {
                console.log("FAILED");
                returnFunction(null);
            }
        })
        .catch((error) => {
            console.log(error);
            returnFunction(null);
        });

}

export function  getSalesPeople (returnFunction){
    console.log("getSales1 ++++++++:getSalesPeople");

    //axios.post(pythonApiIp + 'getSalesPeople', {
    axios.post(serverIp + 'salesApp/getSalesPeopleNew', {
        apiKey: "asdf&dfd",
    })
        .then((response) => {
         
            console.log("getSales12:"+JSON.stringify(response.data,null,3));

            if (response.data.result) {
                console.log("getSales13 true.. getSalesPeople");

                returnFunction(response.data.salesPeople);
           
            } else {
                console.log("FAILED");
                returnFunction(null);
            }
        })
        .catch((error) => {
            console.log(error);
            returnFunction(null);
        });

}

export function  getCustomerList (returnFunction){
    console.log("gtc1 ++++++++:getCustomerList");

    axios.post(pythonApiIp + 'getCustomerList', {
        apiKey: "Pasdf&343k"
    })
        .then((response) => {
         
            console.log("gtc12:"+JSON.stringify(response.data,null,3));

            if (response.data.result) {
                console.log("gtc13 true.. adding customer");

                returnFunction(response.data.customers);
           
            } else {
                console.log("FAILED");
                returnFunction(null);
            }
        })
        .catch((error) => {
            console.log(error);
            returnFunction(null);
        });

}


export function getProjectList (returnFunction, filter, salesPersonId) {
    console.log("filtx ++++++++:getProjectList");
    console.log("filtx2 filter:"+filter);
    console.log("filtx3 salesPersonId filter:"+salesPersonId);

    if(salesPersonId == 0){
        salesPersonId == null
    }

    axios.post(pythonApiIp + 'getProjectList', {
        apiKey: "asdfsdf&343k",
        filter:filter,
        salesPersonId: salesPersonId
    })
        .then((response) => {
           
           // console.log("gpx12 results:"+JSON.stringify(response.data, null, 3));

            if (response.data.result) {
                console.log("true.. adding customer");

                returnFunction(response.data.projects)

            } else {
                console.log("FAILED");
              //  alert(response.data.message);
            }
        })
        .catch((error) => {
            console.log("extt1:"+error);
           
        });
}




// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ApiUtils.js